export const colors = {
  background: '#FAF9F5',
  barBackground: '#e8e7e5',
  surface: '#FFFFFF',
  text: '#282726',
  textMuted: '#666666',
  primary: '#ba4b21',
  secondary: '#3d87c2',
  border: '#AAA',
  shadow: '#D1CEC5',
  overlay: 'rgba(232, 234, 237, 0.9)',
  success: '#3f9b40',
};

export const typography = {
  header: {
    fontFamily: 'JosefinSans_600SemiBold',
    fontSize: 25,
    lineHeight: 32,
  },
  headerLanding: {
    fontFamily: 'FrederickaTheGreat_400Regular',
    fontSize: 25,
    lineHeight: 32,
  },
  body: {
    fontFamily: 'JosefinSans_400Regular',
    fontSize: 16,
    lineHeight: 22,
  },
  bodyBold: {
    fontFamily: 'JosefinSans_600SemiBold',
    fontSize: 16,
    lineHeight: 22,
  },
};
